import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `Für diejenigen, die in Nr.  ${questionDisplayNumber} von ${categoryName} (obligatorisch) mit '${selectText}' geantwortet haben.`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `in Nr. ${questionDisplayNumber} von ${categoryName} „${selectText}“ `
            }
          )
          return `Für diejenigen, die ${messages.join(' oder ')} beantwortet haben. (Obligatorische Frage)`
        }),
    },
    validation: {
      decimal_max_digit: 'Geben Sie bis zur {decimalMaxDigit} Dezimalstelle ein',
    },
  }
}
